import React from 'react';

export const CustomDragPreview: React.FC<{monitorProps: any}> = props => {
    const item = props?.monitorProps?.item;

    return (
        <div className={'customDragPreview'}>
            <div className={'label'}>{item.text}</div>
        </div>
    );
};
